export function scroll() {
  function changeHeader($scrollAmount) {
    if (window.location.pathname !== '/') {
      return;
    }

    const $header = $('.js-reverseHeader');
    const $imgWhite = $('.js-reverseHeader_img-white');
    const $imgBlack = $('.js-reverseHeader_img-black');
    const $navItem = $('.js-reverseHeader_item');

    if ($scrollAmount >= 80) {
      $header.addClass('-reverse');
      $imgBlack.addClass('is-show');
      $imgWhite.removeClass('is-show');
      $navItem.addClass('u-color-black');
    } else if ($scrollAmount < 80) {
      $header.removeClass('-reverse');
      $imgWhite.addClass('is-show');
      $imgBlack.removeClass('is-show');
      $navItem.removeClass('u-color-black');
    }
  }

  function scrollPageTop($scrollAmount) {
    if ($scrollAmount >= 80) {
      $('.js-scrollPageTop_pageTop').addClass('is-show');
      $('.js-scrollPageTop_scroll').removeClass('is-show');
    } else if ($scrollAmount < 80) {
      $('.js-scrollPageTop_scroll').addClass('is-show');
      $('.js-scrollPageTop_pageTop').removeClass('is-show');
    }
  }

  function init() {
    let scrollAmount = 0;

    window.addEventListener('scroll', (event) => {
      scrollAmount = window.scrollY;
      changeHeader(scrollAmount);
      scrollPageTop(scrollAmount);
    });

    $('.js-scrollPageTop').on('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  init();
}
